export const WEAVE_BOOKING_URL =
  "https://book2.getweave.com/5ce19703-2383-4ad8-9b02-4396bac009da/request-appointment?source=WEBSITE";

export const openWeaveBookingInNewTab = (event) => {
  event.preventDefault();
  window.open(
    WEAVE_BOOKING_URL,
    "_blank",
    "noopener,noreferrer",
  );
};